// extracted by mini-css-extract-plugin
export default {"unsaved-changes-modal":"styles__unsaved-changes-modal--4iOFV"};